import React from 'react';
const Header = () => {
  return (
    <div className="ri-header">
      <div className="ri-header-img">
        <img src="/img/chatbot_logo.png" />

        {/* <span>ANIPLUS</span> */}
      </div>
      <i className="ri-arrow-left-s-line" />
      <i className="ri-close-line" />
    </div>
  );
};

export default Header;
